export default __webpack_public_path__ + "static/media/logout.fc7ce600.svg";